import React from 'react';
import InfoTip from './InfoTip';
import { SUPPRESSED_HINT } from './format';

// Headline figure. `display` is pre-formatted so suppressed ("< 5") and
// "No data yet" values render as text instead of animating a number.
function ImpactStat({ label, display, detail, suppressed, accent, info }) {
  return (
    <div className="h-full bg-white rounded-xl border border-gray-200 shadow-sm p-5">
      <p className="flex items-center gap-1 text-xs font-medium uppercase tracking-wide text-gray-500">
        {label}
        <InfoTip text={info} />
      </p>
      <p
        className="mt-2 text-3xl font-semibold tabular-nums"
        style={{ color: accent || '#111827' }}
        title={suppressed ? SUPPRESSED_HINT : undefined}
      >
        {display}
      </p>
      {detail && <p className="mt-1 text-xs text-gray-500">{detail}</p>}
    </div>
  );
}

export default ImpactStat;
